define('util/DSTDateUtil',[
    'moment'
], function (moment) {
    'use strict';

    /**
     * A collection of tools to generate moments and
     * increment moments with respect to DST.
     */
    var DSTDateUtil = {

        generateEndMoment: function (duration, start) {
            var end = moment(start).add(1, duration);
            return end;
        },

        incrementMoments: function (duration, start, end) {
            start.add(1, duration);
            if (end) {
                end.add(1, duration);
            } else {
                return this.generateEndMoment(duration, start);
            }
        }

    };

    return DSTDateUtil;
});

